import { cn } from "@/lib/utils"

interface LogoProps {
  className?: string
  markOnly?: boolean
  size?: "sm" | "md" | "lg" | "xl"
}

const sizeMap = {
  sm: { mark: 22, gap: "gap-1.5", text: "text-sm" },
  md: { mark: 28, gap: "gap-2", text: "text-lg" },
  lg: { mark: 40, gap: "gap-2.5", text: "text-2xl" },
  xl: { mark: 56, gap: "gap-3", text: "text-4xl" },
} as const

export function Logo({ className, markOnly = false, size = "md" }: LogoProps) {
  const s = sizeMap[size]
  return (
    <span
      role="img"
      aria-label="akit"
      className={cn("inline-flex items-center", s.gap, className)}
    >
      <LogoMark size={s.mark} aria-hidden />
      {!markOnly && (
        <span
          aria-hidden
          className={cn(
            "font-extrabold tracking-tight leading-none select-none text-foreground",
            s.text,
          )}
        >
          kit
        </span>
      )}
    </span>
  )
}

interface LogoMarkProps {
  size?: number
  className?: string
  "aria-hidden"?: boolean
}

export function LogoMark({ size = 28, className, ...rest }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...rest}
    >
      <rect width="1024" height="1024" rx="229.1" fill="#3b82f6" />
      <g transform="translate(226.04,788.80) scale(0.49781,-0.49781)">
        <path
          d="M427.679443359375 -19.919921875Q320.91943359375 -19.919921875 237.45947265625 16.6600341796875Q153.99951171875 53.239990234375 106.799560546875 126.43994140625Q59.599609375 199.639892578125 59.599609375 310.39990234375Q59.599609375 403.35986328125 92.279541015625 467.159912109375Q124.95947265625 530.9599609375 182.7593994140625 570.780029296875Q240.559326171875 610.60009765625 315.6593017578125 631.7801513671875Q390.75927734375 652.960205078125 475.599365234375 659.920166015625Q571.039306640625 668.360107421875 629.0992431640625 677.64013671875Q687.1591796875 686.920166015625 713.859130859375 705.8201904296875Q740.55908203125 724.72021484375 740.55908203125 758.880126953125V763.360107421875Q740.55908203125 802.19970703125 722.5391845703125 829.0394287109375Q704.519287109375 855.879150390625 670.759521484375 870.0989990234375Q636.999755859375 884.31884765625 588.64013671875 884.31884765625Q540.560546875 884.31884765625 503.32080078125 869.958984375Q466.0810546875 855.59912109375 441.981201171875 829.8792724609375Q417.88134765625 804.159423828125 408.241455078125 768.95947265625L91.599609375 809.999267578125Q114.079345703125 905.919189453125 178.71923828125 978.2393798828125Q243.359130859375 1050.5595703125 347.6993408203125 1091.27978515625Q452.03955078125 1132 592.000244140625 1132Q695.880859375 1132 786.381103515625 1107.4798583984375Q876.88134765625 1082.959716796875 944.9013671875 1035.359619140625Q1012.92138671875 987.759521484375 1051.101318359375 918.379638671875Q1089.28125 848.999755859375 1089.28125 759.040283203125V0H761.039306640625V156.56005859375H752.079345703125Q721.67919921875 99.31982421875 675.4991455078125 60.099853515625Q629.319091796875 20.8798828125 567.63916015625 0.47998046875Q505.959228515625 -19.919921875 427.679443359375 -19.919921875ZM533.92041015625 211.281005859375Q592.8798828125 211.281005859375 640.2196044921875 235.080810546875Q687.559326171875 258.880615234375 715.5792236328125 300.8603515625Q743.59912109375 342.840087890625 743.59912109375 397.919921875V505.039306640625Q728.799072265625 497.359375 706.2392578125 490.2794189453125Q683.679443359375 483.199462890625 656.69970703125 477.4794921875Q629.719970703125 471.759521484375 602.7001953125 467.3995361328125Q575.680419921875 463.03955078125 551.200439453125 459.279541015625Q499.880615234375 452.03955078125 463.90087890625 434.819580078125Q427.921142578125 417.599609375 409.121337890625 390.73974609375Q390.321533203125 363.8798828125 390.321533203125 326.480224609375Q390.321533203125 289.00048828125 408.92138671875 263.3006591796875Q427.521240234375 237.600830078125 459.760986328125 224.44091796875Q492.000732421875 211.281005859375 533.92041015625 211.281005859375Z"
          fill="#ffffff"
        />
      </g>
    </svg>
  )
}
